<template>
  <span class="c-product-overview__link--orderable-label">
    {{ getProductOverviewTranslations['ProductsOverview.Orderable'] }}
  </span>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('translations', ['getProductOverviewTranslations'])
  }
};
</script>

<style lang="scss">
@import '@/css/src/utilities/_variables';
@import '@/css/src/utilities/_mixins';
@import '@/css/src/utilities/_functions';
@import '~bootstrap/scss/mixins';

.c-product-overview__link {
  &--orderable-label {
    position: absolute;
    bottom: 0;
    left: 30px;
    transform: translateY(50%);
    border-radius: 25px;
    font-size: rem(11);
    color: $success-light;
    font-weight: $font-weight--bold;
    padding: 4px 8px;
    background-color: $label-green-bg;
    display: flex;
    align-items: center;
    gap: 5px;

    &::before {
      content: '';
      width: 7px;
      height: 7px;
      background-color: $success-light;
      display: inline-block;
      border-radius: 100%;
    }
  }
}
</style>
